import { render, staticRenderFns } from "./electronicDocuments.vue?vue&type=template&id=73fd1001&scoped=true"
import script from "./electronicDocuments.vue?vue&type=script&lang=js"
export * from "./electronicDocuments.vue?vue&type=script&lang=js"
import style0 from "./electronicDocuments.vue?vue&type=style&index=0&id=73fd1001&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fd1001",
  null
  
)

export default component.exports